import React from "react";
import { Row, Col } from "reactstrap";

const AddressView = ({ data }) => {
  return (
    <Row>
      <Col>
        <div className="text-xl text-gray-500">
          {data?.addresses?.length > 0 ? (
            <div className="flex gap-1">
              <p className="text-2xl">{data.addresses[0].addressLine1 && data.addresses[0].addressLine1}</p>
              <p className="text-2xl">ตำบล {data.addresses[0].subDistrict && data.addresses[0].subDistrict}</p>
              <p className="text-2xl"> อำเภอ {data.addresses[0].district && data.addresses[0].district}</p>
              <p className="text-2xl">จังหวัด {data.addresses[0].province && data.addresses[0].province}</p>
              <p className="text-2xl">{data.addresses[0].postalCode && data.addresses[0].postalCode}</p>
            </div>
          ) : (
            "-"
          )}
        </div>
      </Col>
    </Row>
  );
};

export default AddressView;
